import { API_ENDPOINT } from "@/constants/appConstants";
import { useRegistrationProps } from "@/context/useRegistrationProps";
import { useMobile } from "@/hooks";
import { Button, User } from "@monsterindia/global-ui-components";
import Lottie from "react-lottie-player";

const RegistrationHeader = () => {
  const isMobile = useMobile();
  const { screenType, hostname } = useRegistrationProps();
  const lottieUrl = window?._siteProps_?.propertiesMap?.logoUrl || "";

  return (
    <header className="z-50 w-full border bg-white px-3">
      <div className="mx-auto flex h-16 w-full items-center justify-between lg:w-[85%!important]">
        {lottieUrl?.includes(".json") ? (
          <Lottie
            path={lottieUrl}
            loop
            play
            style={{
              height: isMobile ? "auto" : "34px",
              width: isMobile ? "90px" : "auto",
            }}
          />
        ) : (
          <img
            src={API_ENDPOINT(hostname).media.founditLogo}
            alt="Foundit Logo"
            className="h-[24px] w-[97px]"
          />
        )}
        {screenType === "MOBILE_NUMBER_EMAIL" && (
          <Button
            label="Login"
            modifier="secondary"
            url="/rio/login"
            leftIcon={<User width={20} height={20} />}
            onClick={() => {}}
          />
        )}
      </div>
    </header>
  );
};

export default RegistrationHeader;
